var map = {
	"../bread/bread.module": [
		"./src/app/bread/bread.module.ts",
		"app-pages-pages-module~bread-bread-module~components-components-module~groups-groups-module",
		"app-pages-pages-module~bread-bread-module~groups-groups-module",
		"bread-bread-module~charts-charts-module~maps-maps-module",
		"bread-bread-module~tables-tables-module",
		"bread-bread-module"
	],
	"./charts/charts.module": [
		"./src/app/pages/charts/charts.module.ts",
		"bread-bread-module~charts-charts-module~maps-maps-module",
		"charts-charts-module"
	],
	"./components/components.module": [
		"./src/app/pages/components/components.module.ts",
		"app-pages-pages-module~bread-bread-module~components-components-module~groups-groups-module"
	],
	"./diary/diary.module": [
		"./src/app/pages/diary/diary.module.ts",
		"diary-diary-module"
	],
	"./editors/editors.module": [
		"./src/app/pages/editors/editors.module.ts",
		"editors-editors-module"
	],
	"./forms/forms.module": [
		"./src/app/pages/forms/forms.module.ts",
		"forms-forms-module"
	],
	"./groups/groups.module": [
		"./src/app/pages/groups/groups.module.ts",
		"app-pages-pages-module~bread-bread-module~components-components-module~groups-groups-module",
		"app-pages-pages-module~bread-bread-module~groups-groups-module",
		"groups-groups-module"
	],
	"./maps/maps.module": [
		"./src/app/pages/maps/maps.module.ts",
		"bread-bread-module~charts-charts-module~maps-maps-module",
		"maps-maps-module"
	],
	"./messages/messages.module": [
		"./src/app/pages/messages/messages.module.ts",
		"messages-messages-module"
	],
	"./miscellaneous/miscellaneous.module": [
		"./src/app/pages/miscellaneous/miscellaneous.module.ts",
		"miscellaneous-miscellaneous-module"
	],
	"./news/news.module": [
		"./src/app/pages/news/news.module.ts",
		"news-news-module"
	],
	"./tables/tables.module": [
		"./src/app/pages/tables/tables.module.ts",
		"bread-bread-module~tables-tables-module",
		"tables-tables-module"
	],
	"app/pages/auth/auth.module": [
		"./src/app/pages/auth/auth.module.ts",
		"app-pages-auth-auth-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"app-pages-pages-module~bread-bread-module~components-components-module~groups-groups-module",
		"app-pages-pages-module~bread-bread-module~groups-groups-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;